<template>
    <div class="socket-debug-bar">
        <div class="flex justify-between w-full">
            <h1 class="font-size-18 text-white m-0 p-0">Socket Log</h1>
            <a @click.prevent="close" class="text-white" href="">[Close]</a>
        </div>
        <div class="logs">
            <ul class="list-reset" id="log-msgs">
                <li :key="index" v-for="(log, index) in logs" class="text-white font-size-12">{{ log }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocketDebugBar',

    props: {
        logs: {}
    },

    methods: {
        close () {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
    .socket-debug-bar {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 99999;
        background-color: rgba(0, 0, 0, 0.6);
        padding: 1rem;
        overflow: scroll;
    }
</style>
